import React from "react";
import Oops from "./views/Pages/Error/Oops";
import { quickLogEvent } from "./services/LogService";
import { TrackingEvent } from "./services/Tracking";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    console.log("Error: ", error);
    console.log("ErrorInfo: ", errorInfo);

    // Log Error
    const displayError = "Client Portal Error: " + error;
    quickLogEvent(displayError, 1, errorInfo);

    // Track Error with Analytics
    TrackingEvent("Error", displayError, displayError);
  }

  render() {
    if (this.state.hasError) {
      // Error path
      return <Oops message="Sorry, we have encountered a problem."></Oops>;
    }
    // Normally, just render children
    return this.props.children;
  }
}

export default ErrorBoundary;
